const version = '0.1.0-SNAPSHOT';

export default version;
